// extracted by mini-css-extract-plugin
export var item = "GalleryImage-module--item--35b08";
export var video = "GalleryImage-module--video--582bf";
export var picture = "GalleryImage-module--picture--49b5b";
export var image = "GalleryImage-module--image--4e07f";